import { Component, OnInit } from '@angular/core';
import { MasterDataService } from 'src/app/services/master-data.service';

@Component({
  selector: 'app-official-details',
  templateUrl: './official-details.component.html',
  styleUrls: ['./official-details.component.css'],
})
export class OfficialDetailsComponent implements OnInit {
  user: any;

  constructor(private masterDataService: MasterDataService) {}

  ngOnInit(): void {
    this.loadUserDetails();
  }

  loadUserDetails() {
    this.masterDataService.getUserProfile().subscribe((res) => {
      console.log(res);
      this.user = res;
    });
  }
}
